module.exports = __webpack_public_path__ + "img/bnp.68cfb896.svg";